
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/national-curriculum",
      function () {
        return require("private-next-pages/national-curriculum/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/national-curriculum"])
      });
    }
  